import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

export type CeilingRefusal = "OVER_CEILING" | "VALUE_REQUIRED" | "OTHER_CURRENCY";

const REFUSALS: Record<string, CeilingRefusal> = {
  zz_FrameworkAgreementApiErrorCodeMiniCompetitionExceedsTheFrameworkAgreementsMaximumValue: "OVER_CEILING",
  zz_FrameworkAgreementApiErrorCodeMiniCompetitionNeedsAValueUnderTheFrameworkAgreementsMaximumValue: "VALUE_REQUIRED",
  zz_FrameworkAgreementApiErrorCodeValueNotInTheFrameworkAgreementsCurrency: "OTHER_CURRENCY",
};

export const ceilingRefusalOf = (e: unknown): CeilingRefusal | null =>
  isFetchBaseQueryError(e) && isApiErrorDto(e.data) ? REFUSALS[e.data.errorCode] ?? null : null;
